module.exports = __webpack_public_path__ + "static/img/a2.13c813ad.jpg";